module.exports = __webpack_public_path__ + "img/countersquare.dde30dc1.webp";